import { render, staticRenderFns } from "./v-rightBlock.vue?vue&type=template&id=31e70b72&"
import script from "./v-rightBlock.vue?vue&type=script&lang=js&"
export * from "./v-rightBlock.vue?vue&type=script&lang=js&"
import style0 from "./v-rightBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports